"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _EditorContainer = require("../Editor/EditorContainer");
var _Logger = _interopRequireDefault(require("../../Utils/Logger"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var logger = new _Logger["default"]('CanvasContainer');
var CanvasContainer = function CanvasContainer(_ref) {
  var canvasPosition = _ref.canvasPosition,
    classes = _ref.classes,
    children = _ref.children;
  logger.log('render CanvasContainer');
  var left = canvasPosition.left,
    top = canvasPosition.top;
  var style = {
    transform: "translate(".concat(left, "px, ").concat(top, "px)")
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.canvasContainer,
    style: style
  }, children);
};
CanvasContainer.propTypes = {
  canvasPosition: _propTypes["default"].shape({
    left: _propTypes["default"].number.isRequired,
    top: _propTypes["default"].number.isRequired
  }).isRequired,
  classes: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = (0, _withStyles["default"])(_styles["default"], {
  name: 'Designer-CanvasContainer'
})((0, _EditorContainer.withCanvasPosition)(CanvasContainer));